const DIGIT_TOKEN_REGEX = /(?:^|[^\d])(\d{4,6})(?!\d)/;

export const normalizeRegionId = (value) => {
  if (value === null || value === undefined) return null;
  if (typeof value === "number") {
    if (!Number.isFinite(value)) return null;
    return String(Math.trunc(value));
  }

  const cleaned = String(value).trim().replace(/,/g, "");
  if (!cleaned) return null;

  const parsed = Number(cleaned);
  if (Number.isFinite(parsed)) return String(Math.trunc(parsed));

  const embedded = cleaned.match(DIGIT_TOKEN_REGEX);
  return embedded?.[1] || null;
};

export const parseRegionIdAsNumber = (value) => {
  const normalizedId = normalizeRegionId(value);
  if (!normalizedId) return null;

  const parsed = Number(normalizedId);
  return Number.isFinite(parsed) ? Math.trunc(parsed) : null;
};

export const normalizeRidingName = (value) => {
  const normalized = String(value || "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, " ")
    .trim();
  return normalized || null;
};

export const toRidingIdLookupKey = (value) => {
  const id = normalizeRegionId(value);
  return id ? `id:${id}` : null;
};

export const toRidingNameLookupKey = (value) => {
  const normalizedName = normalizeRidingName(value);
  return normalizedName ? `name:${normalizedName}` : null;
};

export const normalizeRidingLookupKey = (value) => {
  if (value === null || value === undefined) return null;
  const key = String(value).trim();
  if (!key) return null;

  if (/^id:/i.test(key)) return toRidingIdLookupKey(key.slice(3));
  if (/^name:/i.test(key)) return toRidingNameLookupKey(key.slice(5));

  return toRidingIdLookupKey(key) || toRidingNameLookupKey(key);
};
